import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GridSync, IIdentity } from '.';

export interface SaveConfig<T extends IIdentity> {
  save?: (changes: GridSync<T>) => Observable<T[]>;
  beforeSave?: (changes: GridSync<T>) => Observable<boolean>;
  onError?: (error: HttpErrorResponse) => void;
  errorTitle?: string;
  errorMessage?: string;
  isExternalSave?: boolean;
}
